import React, { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import { evidences_config } from "./evidences_config";
import MappedText from "../../../../../../instand/reports/create-report/shared-components/mapText";
import { connect } from "react-redux";
import { Container } from "@mui/system";
import ScoreCategoryChips from "./ScoreCategoryChips";
import OncoEvidenceCard from "./OncoEvidenceCard";



function getRowForType(selectedRows, dataType) {
    if (!selectedRows || !Array.isArray(selectedRows)) return null;
    const found = selectedRows.find(item => item.data_type === dataType);
    if (!found) return null;
    if (found.data_row && found.data_row.length > 0) {
        return found.data_row[0];
    }
    return null;
}

function noRowSelected(selected_table_rows) {
    if (!selected_table_rows || selected_table_rows.length === 0) {
        return true;
    }
    return selected_table_rows.every(
        (item) => !item.data_row || item.data_row.length === 0
    );
}
function OncoEvidencesPanel({ selected_table_rows }) {

    const [evidenceInfo, setEvidenceInfo] = useState([]);
    const [ocScore, setOcScore] = useState(null);

    const [expandedIndexes, setExpandedIndexes] = useState([]);

    const noSelection = noRowSelected(selected_table_rows);

    const snvSomaticRow = getRowForType(selected_table_rows, "SNV_Somatic");
    const cnvRow = getRowForType(selected_table_rows, "CNV");

    useEffect(() => {
        if (snvSomaticRow) {
            const { Evidence, OCScore } = snvSomaticRow;

            let evidencesArray = [];
            if (Array.isArray(Evidence)) {
                evidencesArray = Evidence;
            } else if (typeof Evidence === "string") {
                evidencesArray = Evidence.split(",").map((e) => e.trim());
            }

            const foundEvidences = evidencesArray.map((evidenceKey) => {
                const evidenceConfig = evidences_config.find(
                    (config) => config.key === evidenceKey
                );
                return evidenceConfig
                    ? { ...evidenceConfig.values[0], key: evidenceKey }
                    : { key: evidenceKey };
            });

            setEvidenceInfo(foundEvidences);
            setOcScore(OCScore);
        } else {
            setEvidenceInfo([]);
            setOcScore(null);
        }
    }, [snvSomaticRow]);

    if (noSelection) {
        return (
            <Container>
                <Typography variant="h6">
                    <MappedText text="OncoEvidences" />
                </Typography>
                <Typography variant="body1" style={{ marginTop: 8 }}>
                    <MappedText text="No variant selected. Please select a row to see OncoEvidences." />
                </Typography>
            </Container>
        );
    }

    if (cnvRow) {
        return (
            <Box>
                <Typography
                    variant="body1"
                    style={{
                        fontSize: "16px",
                        color: "gray",
                        textAlign: "left",
                        fontWeight: "bold",
                        padding: "10px 0 10px 24px",
                    }}
                >
                    <MappedText text="OncoEvidences" />
                </Typography>
                <Typography
                    variant="body1"
                    style={{
                        fontSize: "16px",
                        color: "gray",
                        textAlign: "left",
                        paddingLeft: "24px",
                        paddingBottom: "24px",
                    }}
                >
                    <MappedText text="OncoEvidences are not available for CNVs yet" />
                </Typography>
            </Box>
        );
    }

    const handleExpandClick = (index) => {
        setExpandedIndexes((prevExpanded) =>
            prevExpanded.includes(index)
                ? prevExpanded.filter((i) => i !== index)
                : [...prevExpanded, index]
        );
    };


    return (
        <Container>
            <Typography variant="h6">
                <MappedText text={"OncoEvidences"} />
            </Typography>
            {evidenceInfo.length > 0 ? (
                <Box>
                    <ScoreCategoryChips ocScore={ocScore} />
                    {evidenceInfo.map((info, index) => (
                        <OncoEvidenceCard
                            key={index}
                            info={info}
                            index={index}
                            expanded={expandedIndexes.includes(index)}
                            onExpandClick={handleExpandClick}
                        />
                    ))}
                </Box>
            ) : (
                <Typography variant="body1"><MappedText text={"There are 0 onco evidences"} /></Typography>
            )}
        </Container>
    );
}

function mapStateToProps(state) {
    if (state.selected_table_rows !== undefined) {
        return {
            selected_table_rows: state.selected_table_rows
        }
    }
    else {
        return { selected_table_rows: [] }
    }
}

export default connect(mapStateToProps)(OncoEvidencesPanel);